"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ContextualMessage.scss");
var Link_1 = require("../Link");
/**
 * Note: For user-initiated alerts which occur most frequently at the top of page or section, please use the <a href="#/Atoms/Alert" class="rsg--link-45">Alert</a> component in the library.<br /><br />
 * Contextual messages occur on page load and are not user-initiated. They can be placed anywhere on the page but must be in close proximity to the relevant content and are usually placed inside a component, such as a card or a table. Contextual messages span the width of the container they are placed within.
 */
var ContextualMessage = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    return (React.createElement("div", { className: "flex flex-wrap justify-between rel", "data-testid": testId },
        React.createElement("div", { className: "flex flex-items-stretch " + styles.msgPadding },
            data.icon && React.createElement("span", { className: styles.svgSize }, data.icon),
            (data.text || options.showLink) && (React.createElement("span", { className: "color-ui-dark-gray mar-b-none " + (options.type === 2
                    ? " " + styles.marginTop2
                    : options.type === 3
                        ? " " + styles.marginTop3
                        : " " + styles.marginTop1) + (data.className ? " " + data.className : "") },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: data.text } }),
                options.showLink && (React.createElement(Link_1.default, { className: styles.linkColor, kind: "textMedium", url: options.linkUrl }, options.link)))))));
};
exports.default = ContextualMessage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ContextualMessage/ContextualMessage.js
// module id = 1766
// module chunks = 8